import React, { ReactElement } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/theme-textmate';
import 'ace-builds/src-noconflict/ext-language_tools';

import {
    FONT_SIZE_CODE_EDITOR
} from '../../../constants/common.constants';

interface IProps {
    value: string;
    onChange: (code: string) => void;
    mode: string;
    maxLines?: number;
    minLines?: number;
    fontSize?: number;
    validationError?: string;
    showPrintMargin?: boolean;
    label?: string | ReactElement;
    showGutter?: boolean;
    highlightActiveLine?: boolean;
    width?: string;
    height?: string;
}

export const CodeEditor = (props: IProps) => {
    const {
        value,
        onChange,
        mode,
        maxLines,
        minLines,
        fontSize,
        validationError,
        showPrintMargin,
        label,
        showGutter,
        highlightActiveLine,
        width,
        height
    } = props;

    return (
        <div className='m-top-15px'>
            <label className='oe-form-field__title'>{label}</label>
            <AceEditor
                mode={mode}
                theme='textmate'
                onChange={onChange}
                fontSize={fontSize}
                showPrintMargin={showPrintMargin}
                showGutter={showGutter}
                highlightActiveLine={highlightActiveLine}
                value={value}
                setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 1,
                    useWorker: false,
                }}
                minLines={minLines}
                maxLines={maxLines}
                width={width}
                height={height}
            />
            {validationError && <span className='oe-form-field__error'>{validationError}</span>}
        </div>
    );
};

CodeEditor.defaultProps = {
    fontSize: FONT_SIZE_CODE_EDITOR,
    mode: 'css',
    showPrintMargin: false,
    showGutter: true,
    highlightActiveLine: true,
    width: '100%',
    height: '100%',
};
